import React from 'react';
import { BLOCKS, INLINES } from '@contentful/rich-text-types';
import { IKeyFields } from '@/types/simo/products';
import './styles.scss';

export const getAllEntriesFromResource = (fields: IKeyFields[]) => {
  const entries = {};
  fields.forEach((item) => {
    entries[item.key] = item.textValue || item.imageValue?.url;
  });
  return entries;
};

export const bodyTextRenderOptions = {
  renderNode: {
    [INLINES.HYPERLINK]: ({ data }: any, children: any) => (
      <a className="ys-link" href={data.uri} target={`${data.uri}`} rel={`${data.uri}`}>
        {children}
      </a>
    ),
    [BLOCKS.PARAGRAPH]: (_node: any, children: any) => (
      <p className="contentful__body-text">{children}</p>
    )
  },
  renderText: (text: string) =>
  text.split("\n").flatMap((text, i) => [i > 0 && <br />, text])
};

export const bodyTextRenderOptionsExtraSpacing = {
  renderNode: {
    [INLINES.HYPERLINK]: ({ data }: any, children: any) => (
      <a className="ys-link" href={data.uri} target={`${data.uri}`} rel={`${data.uri}`}>
        {children}
      </a>
    ),
    [BLOCKS.PARAGRAPH]: (_node: any, children: any) => (
      <p className="contentful__body-text contentful__body-text--padding-10">{children}</p>
    )
  },
};

export const bodyTextRenderOptionsExtraSpacingBotttom = {
  renderNode: {
    [INLINES.HYPERLINK]: ({ data }: any, children: any) => (
      <a className="ys-link" href={data.uri} target={`${data.uri}`} rel={`${data.uri}`}>
        {children}
      </a>
    ),
    [BLOCKS.PARAGRAPH]: (_node: any, children: any) => (
      <p className="contentful__body-text pb-3">{children}</p>
    )
  },
};

export const legalTextRenderOptions = {
  renderNode: {
    [INLINES.HYPERLINK]: ({ data }: any, children: any) => (
      <a className="ys-link" href={data.uri} target={`${data.uri}`} rel={`${data.uri}`}>
        {children}
      </a>
    ),
    [BLOCKS.PARAGRAPH]: (_node: any, children: any) => (
      <p className="contentful__legal-text">{children}</p>
    )
  },
  renderText: (text: string) =>
  text.split("\n").flatMap((text, i) => [i > 0 && <br />, text])
};

export const uspTextRenderOptions = {
  renderNode: {
    [INLINES.HYPERLINK]: ({ data }: any, children: any) => (
      <a className="ys-link" href={data.uri} target={`${data.uri}`} rel={`${data.uri}`}>
        {children}
      </a>
    ),
    [BLOCKS.PARAGRAPH]: (_node: any, children: any) => (
      <p className="usp__list-item-text">{children}</p>
    )
  },
};
